import { constructs } from "../api/contructs";
import { createSyncedApiHook } from "../api/createSyncedApiHook";
import { createUseItemHook, createUseItemsHook } from "./createUseItemsHook";

const construct = constructs.palette;

export const usePalette = createUseItemHook(construct);
export const usePalettes = createUseItemsHook(construct);
export const usePalettesApi = createSyncedApiHook(construct);